"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var usePathnameWithoutSplatRouteParams_exports = {};
__export(usePathnameWithoutSplatRouteParams_exports, {
  usePathnameWithoutSplatRouteParams: () => usePathnameWithoutSplatRouteParams
});
module.exports = __toCommonJS(usePathnameWithoutSplatRouteParams_exports);
var import_react = require("@remix-run/react");
const usePathnameWithoutSplatRouteParams = () => {
  const params = (0, import_react.useParams)();
  const { pathname } = (0, import_react.useLocation)();
  const splatRouteParam = params["*"] || "";
  const path = pathname.replace(splatRouteParam, "").replace(/\/$/, "").replace(/^\//, "").trim();
  return `/${path}`;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  usePathnameWithoutSplatRouteParams
});
//# sourceMappingURL=usePathnameWithoutSplatRouteParams.js.map